import axios from "axios";

export const completeAddress = (search: string) => {
  const key = '27578508518692519';
  return axios.get(`https://us-autocomplete.api.smartystreets.com/suggest?key=${key}&prefix=${search}&suggestions=5`);
};